import { contact } from '@/mocks/homeData';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            {contact.title}
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            {contact.desc}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 max-w-3xl mx-auto">
          {contact.methods.map((m, i) => (
            <div
              key={i}
              className="flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200/60"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${m.icon} text-xl`}></i>
              </div>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{m.label}</span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{m.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}